export default {
  songPage: {
    tabs: {
      cours: 'Cours',
      infos: 'Infos',
      chords: 'Accords / Empreintes',
      rhythmics: 'Rythmiques',
      lyrics: 'Paroles',
      skills: 'Compétences'
    },
    learnModal: {
      title: 'Comment veux-tu jouer ?',
      freeMode: 'Exploration libre',
      freeModeDesc: 'Joue librement, sans guidage',
      teacherMode: 'Apprendre avec le prof',
      cancel: 'Annuler',
    },
    songUnavailable: 'Désolé, cette chanson ne semble pas disponible pour le moment. Veuillez réessayer plus tard.'
  },

  versionInfosPanel: {
    play: 'Apprendre',
    partition: 'Partition',
    piano: 'Piano ',
    syncPianoVoice: 'Synchro piano-voix',
    tempo: 'Tempo:',
    style: 'Style:',
    score: 'Score:',
    pieceContains: 'Le morceau contient :',
    editLyrics: 'Modifier les paroles',
    optionReservedPremium: 'Cette option est réservée aux membres avec un abonnement premium.',
    subscribe: 'S\'abonner',
    noPartitionAvailable: 'Aucune partition pour ce morceau',
    mainRhythmics: 'rythmiques principales',
    of: 'dont',
    known: 'connues et',
    mastered: 'maitrisées.',
    handprints: 'empreintes',
    skillsValidated: 'compétences validées',
    listenSong: 'Écouter le morceau',
    downloadPartition: 'Télécharger partition'
  },

  chordsTab: {
    chords: 'Accords',
    handprints: 'Empreintes',
    displayOf: 'Affichage des',
    hands: 'Mains',
    bothHands: 'Les deux mains',
    leftHand: 'Main gauche',
    rightHand: 'Main droite'
  },

  lyricsTab: {
    noLyricsInPart: 'Aucune paroles dans cette partie'
  },

  skillsTab: {
    noSkillsAssociated: 'Aucune compétence associée à ce morceau.',
    sortByMastery: 'Par maîtrise',
    sortByDifficulty: 'Par difficulté',
    tabCompetences: 'Compétences',
    tabEmpreintes: 'Empreintes',
    tabRythmiques: 'Rythmiques',
  },

  infosTab: {
    structureAndProgress: 'Structure et progrès du morceau',
    structure: 'Structure',
    resume: 'Reprendre',
    otherVersions: 'Autres versions',
    associatedChallenges: 'Challenges associés',
    summary: 'Résumé',
    skills: 'compétence{plural}',
    recognize: 'reconnue{plural}',
    validated: 'validée{plural}',
    inProgress: 'en cours',
    notStarted: 'à travailler',
    blocked: 'bloquée{plural}',
    noSkills: "Aucune compétence associée à ce morceau."
  },

  rhythmicsTab: {
    noRhythmics: 'Aucune rythmiques'
  },

  songPlayability: {
    playability: 'Jouabilité',
    pieceRangeDescription: 'Ce morceau va du <b>{minKey}</b> au <b>{maxKey}</b> sur <b>{octaves} octaves</b> et nécessite donc un clavier avec au moins <b>{keys}</b> touches.'
  },

  linkedPlayableList: {
    noContentAvailable: 'Aucun contenu disponible',
  },
  downloadPartitionPage: {
    downloading: 'Téléchargement de la partition en cours...',
    downloadCompleted: 'Le téléchargement de la partition est terminé',
    downloadFailed: 'Le téléchargement de la partition a échoué',
    back: 'Retour',
    downloadError: 'Erreur lors du téléchargement de la partition',
  },
  versionType: {
    inspired: 'Version inspirée',
    simplified: 'Version simplifiée',
    original: 'Version originale',
  },
  partClassesList: {
    fullPieceConsolidation: 'Jouer le morceau en entier',
  }
};
